import './styling/nav.css';
import { useState, useEffect } from "react";

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (

    <nav className={`nav ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-inner">
      <div className="nav-links">
      <a href="#home">Home</a>
      <a href="#projects">Projects</a>
      <a href="#skills">Skills</a>
      <a href="#experience">Experience</a>
      <a href="#education">Education</a>
    </div>

      <a href="/resume.pdf"
        target="_blank"
        rel="noreferrer"
        className="resume-btn">Resume</a>
              </div>

    </nav>

  );
}
